import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

const blogData = [
  { 
    title: "How To Choose The Right Car", 
    meta: "News / 12 April 2024", 
    img: "/assets/bg_3.jpg"
  },
  { 
    title: "Which plan is right for me?", 
    meta: "News / 10 April 2024", 
    img: "/assets/bg_3.jpg" 
  },
  { 
    title: "Enjoy Speed, Choice & Total Control", 
    meta: "News / 08 April 2024", 
    img: "/assets/bg_3.jpg"
  },
];

const BlogCard = ({ title, meta, img }) => (
  <div className="rounded-lg shadow-lg overflow-hidden relative bg-slate-800 transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-2xl">
    <div className="h-48">
      <img src={img} alt={title} className="w-full h-full object-cover" />
    </div>
    <div className="p-6">
      <h3 className="font-bold text-lg mb-2 text-white">{title}</h3>
      <p className="text-sm text-slate-400">{meta}</p>
    </div>
    <div className="absolute bottom-6 right-6 text-amber-400">
      <FaArrowRight size={24} />
    </div>
  </div>
);

const BlogList = () => {
  return (
    <section className="bg-slate-950 py-16 px-4 sm:px-6 lg:px-8">
      {/* Updated: Added a custom yellow shadow to the container */}
      <div className="bg-slate-900 rounded-3xl p-8 ring-4 ring-amber-400/50 shadow-2xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-2">Our Blogs</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogData.map((post, index) => (
            <BlogCard key={index} {...post} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogList;